/* ==========================================================================
   TestHelden v2 · assets/th-diagramm.js · Stand 21.10.2026
   Dynamische Diagramme im Artikeltext (Blog-Generator der Plattform, lib/blog-generator/diagramm-daten.ts).
   Philipp 21.10.2026: „Warum sind die Graphen als Bilder integriert und nicht dynamisch?“

   Eingabe: <figure class="th-diagramm" data-diagramm="{JSON}"><img …><figcaption>…</figcaption></figure>
   JSON: {v:1, art:"linie"|"gruppiert"|"balken", titel, einheit:"%"|"€"|"", kategorien:[…],
          reihen:[{name, werte:[Zahl|null], roh:[Zelltext|null]}]}

   Progressive Verbesserung: Das Skript zeichnet aus den Daten ein SVG (scharf, responsiv, Tooltip beim
   Antippen und Hover, Pfeiltasten, Einblenden beim Scrollen). Das PNG bleibt versteckt im DOM für Druck,
   Teilen und Bildersuche; ohne JavaScript, ohne Daten oder bei kaputten Daten bleibt es sichtbar.
   Barrierefreiheit: Fläche mit role="img" und dem alt-Text des PNG als Name; die Tabelle unter dem
   Diagramm bleibt die zugängliche Datenquelle. Unter 600 px Breite werden Balkendiagramme mit mehr als
   drei Kategorien zu liegenden Balken (Schrift mindestens 13 px), die Linie zeigt Werte nur am letzten
   Punkt und beim Antippen. Texte immer über textContent (Daten sind fremder Inhalt).
   ========================================================================== */
(function (window, document) {
  'use strict';
  if (window.thDiagramm) { return; }

  var NS = 'http://www.w3.org/2000/svg';
  /* CI: Navy, Hero Red, Grau (wie das PNG, diagramm-bild.ts) */
  var FARBE = ['#00214E', '#F15E4C', '#8A99B4'];
  /* Werte als Text: Navy, Rot im Textton (Kontrast 4,9 : 1), Grau im Textton */
  var WERT_FARBE = ['#00214E', '#C4432F', '#4B5A73'];
  var TEXT = '#4B5A73';
  var TEXT_STARK = '#1D2A3D';
  var GITTER = '#E3E7EE';
  var NULLLINIE = '#B8C2D3';
  var KOMPAKT = 600;
  var reduziert = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var alle = [];
  var zaehler = 0;

  /* ── Daten prüfen (dieselben Regeln wie normalisiereDiagrammDaten auf der Plattform) ── */
  function istText(x, max) { return typeof x === 'string' && /\S/.test(x) && x.length <= max; }
  function pruefe(d) {
    if (!d || typeof d !== 'object' || d.v !== 1) { return null; }
    if (['linie', 'gruppiert', 'balken'].indexOf(d.art) < 0 || ['%', '€', ''].indexOf(d.einheit) < 0 || !istText(d.titel, 300)) { return null; }
    var k = d.kategorien;
    if (!Array.isArray(k) || k.length < 1 || k.length > 20 || !k.every(function (x) { return istText(x, 120); })) { return null; }
    var r = d.reihen;
    if (!Array.isArray(r) || r.length < 1 || r.length > 3) { return null; }
    var werte = 0;
    for (var s = 0; s < r.length; s++) {
      var x = r[s];
      if (!x || !istText(x.name, 120) || !Array.isArray(x.werte) || !Array.isArray(x.roh) || x.werte.length !== k.length || x.roh.length !== k.length) { return null; }
      for (var i = 0; i < k.length; i++) {
        var w = x.werte[i];
        var t = x.roh[i];
        if (w === null && t === null) { continue; }
        if (typeof w !== 'number' || !isFinite(w) || w < 0 || !istText(t, 40)) { return null; }
        werte++;
      }
    }
    return werte ? d : null;
  }

  /* ── Zahlen und Texte ── */
  function zahl(v, einheit) {
    var s;
    try { s = v.toLocaleString('de-DE', { maximumFractionDigits: 1 }); } catch (e) { s = String(Math.round(v * 10) / 10).replace('.', ','); }
    return einheit === '%' ? s + ' %' : einheit === '€' ? s + ' €' : s;
  }
  /* Wert wie in der Tabelle, kurz: „320 Euro“ → „320 €“ (die Zahl bleibt Zeichen für Zeichen) */
  function kurz(roh) {
    return String(roh).replace(/\s*(?:Euro|EUR)\b/gi, ' €').replace(/\s*Prozent\b/gi, ' %').replace(/\s+/g, ' ').trim().replace(/ (?=[%€])/g, ' ');
  }
  /* Achse ab 0 wie im PNG: Quoten bis 100 %, sonst höchstens 5 runde Schritte */
  function achse(max, einheit) {
    if (einheit === '%' && max > 55 && max <= 100) { return { max: 100, schritt: 20 }; }
    var roh = Math.max(max * 1.12, 1);
    var potenz = Math.pow(10, Math.floor(Math.log(roh / 5) / Math.LN10));
    var f = [1, 2, 2.5, 5, 10, 20, 25, 50];
    for (var i = 0; i < f.length; i++) {
      var s = f[i] * potenz;
      if (Math.ceil(roh / s - 1e-9) <= 5) { return { max: Math.ceil(roh / s - 1e-9) * s, schritt: s }; }
    }
    return { max: roh, schritt: roh / 5 };
  }
  var leinwand = null;
  function breite(text, groesse, fett, familie) {
    if (leinwand === null) {
      try { leinwand = document.createElement('canvas').getContext('2d') || false; } catch (e) { leinwand = false; }
    }
    if (!leinwand) { return String(text).length * groesse * (fett ? 0.56 : 0.5); }
    leinwand.font = (fett ? '700 ' : '400 ') + groesse + 'px ' + familie;
    return leinwand.measureText(String(text)).width;
  }
  /* Beschriftung in höchstens zwei Zeilen (Klammerzusatz bzw. hintere Wörter in die zweite); null, wenn es nicht passt */
  function umbrechen(text, platz, groesse, familie) {
    if (breite(text, groesse, false, familie) <= platz) { return [text]; }
    var teile = null;
    var k = text.indexOf(' (');
    if (k > 0) {
      teile = [text.slice(0, k), text.slice(k + 1)];
    } else {
      var w = text.split(' ');
      var best = Infinity;
      for (var i = 1; i < w.length; i++) {
        var a = w.slice(0, i).join(' ');
        var b = w.slice(i).join(' ');
        var m = Math.max(breite(a, groesse, false, familie), breite(b, groesse, false, familie));
        if (m < best) { best = m; teile = [a, b]; }
      }
    }
    if (!teile) { return null; }
    for (var j = 0; j < teile.length; j++) { if (breite(teile[j], groesse, false, familie) > platz) { return null; } }
    return teile;
  }
  /* Stehende Balken: Wörter auf höchstens drei Zeilen bis `platz` verteilen (ein einzelnes längeres Wort bleibt ganz) */
  function zeilenUmbruch(text, platz, groesse, familie) {
    var zeilen = [];
    var akt = '';
    text.split(' ').forEach(function (wort) {
      var probe = akt ? akt + ' ' + wort : wort;
      if (!akt || breite(probe, groesse, false, familie) <= platz) { akt = probe; } else { zeilen.push(akt); akt = wort; }
    });
    if (akt) { zeilen.push(akt); }
    return zeilen.length <= 3 ? zeilen : null;
  }
  /* Keine Beschriftung berührt die der Nachbargruppe in derselben Zeile oder ragt aus der Fläche */
  function beschriftungPasst(zeilen, gruppe, x0, W, groesse, familie) {
    var br = zeilen.map(function (z) { return z.map(function (t) { return breite(t, groesse, false, familie); }); });
    for (var i = 0; i < br.length; i++) {
      var mitte = x0 + gruppe * (i + 0.5);
      for (var z = 0; z < br[i].length; z++) {
        var w = br[i][z];
        if (mitte - w / 2 < 1 || mitte + w / 2 > W - 1) { return false; }
        if (i + 1 < br.length && br[i + 1][z] !== undefined && w / 2 + br[i + 1][z] / 2 + 8 > gruppe) { return false; }
      }
    }
    return true;
  }
  /* Notfalls kürzen (liegende Balken: die Zeile hat die volle Breite, das trifft nur sehr lange Namen) */
  function kuerzen(text, platz, groesse, familie) {
    var t = text;
    while (t.length > 4 && breite(t + '…', groesse, false, familie) > platz) { t = t.slice(0, -1); }
    return t === text ? t : t.replace(/\s+$/, '') + '…';
  }
  function r1(v) { return Math.round(v * 10) / 10; }

  /* ── DOM ── */
  function el(tag, klasse, eltern) {
    var e = document.createElement(tag);
    if (klasse) { e.className = klasse; }
    if (eltern) { eltern.appendChild(e); }
    return e;
  }
  function svg(tag, attr, eltern) {
    var e = document.createElementNS(NS, tag);
    for (var k in attr) { if (Object.prototype.hasOwnProperty.call(attr, k) && attr[k] !== null && attr[k] !== undefined) { e.setAttribute(k, attr[k]); } }
    if (eltern) { eltern.appendChild(e); }
    return e;
  }
  /* Text mit vertikaler Mitte bei y */
  function schrift(eltern, inhalt, x, y, o) {
    var t = svg('text', { x: r1(x), y: r1(y + o.groesse * 0.35), 'font-size': o.groesse, 'font-weight': o.fett ? 700 : 400, fill: o.farbe || TEXT, 'text-anchor': o.anker || 'start', 'class': o.klasse || null }, eltern);
    t.textContent = inhalt;
    return t;
  }
  /* Balken mit gerundetem Datenende (4 px), an der Basis gerade */
  function balkenPfad(x, y, w, h, quer) {
    if (w <= 0 || h <= 0) { return null; }
    var r;
    if (!quer) {
      r = Math.min(4, w / 2, h);
      return 'M' + r1(x) + ' ' + r1(y + h) + 'V' + r1(y + r) + 'Q' + r1(x) + ' ' + r1(y) + ' ' + r1(x + r) + ' ' + r1(y) + 'H' + r1(x + w - r) + 'Q' + r1(x + w) + ' ' + r1(y) + ' ' + r1(x + w) + ' ' + r1(y + r) + 'V' + r1(y + h) + 'Z';
    }
    r = Math.min(4, h / 2, w);
    return 'M' + r1(x) + ' ' + r1(y) + 'H' + r1(x + w - r) + 'Q' + r1(x + w) + ' ' + r1(y) + ' ' + r1(x + w) + ' ' + r1(y + r) + 'V' + r1(y + h - r) + 'Q' + r1(x + w) + ' ' + r1(y + h) + ' ' + r1(x + w - r) + ' ' + r1(y + h) + 'H' + r1(x) + 'Z';
  }
  function maxWert(d) {
    var m = 0;
    d.reihen.forEach(function (r) { r.werte.forEach(function (w) { if (w !== null && w > m) { m = w; } }); });
    return m;
  }
  function ticks(a) {
    var out = [];
    for (var v = 0; v <= a.max + 1e-9; v += a.schritt) { out.push(Math.round(v * 100) / 100); }
    return out;
  }
  function svgWurzel(W, H) {
    return svg('svg', { 'class': 'th-diagramm__svg', viewBox: '0 0 ' + W + ' ' + H, width: W, height: H, 'aria-hidden': 'true', focusable: 'false' });
  }

  /* ── Layout: Linie ── */
  function layoutLinie(d, W, kompakt, fam) {
    var n = d.kategorien.length;
    var fs = kompakt ? 13 : 14;
    var fw = kompakt ? 13 : 14;
    var H = kompakt ? 260 : Math.max(280, Math.min(400, Math.round(W * 0.48)));
    var a = achse(maxWert(d), d.einheit);
    var t = ticks(a);
    var tickText = t.map(function (v) { return zahl(v, d.einheit); });
    var links = Math.ceil(Math.max.apply(null, tickText.map(function (x) { return breite(x, fs, false, fam); }))) + 10;
    var labels = d.reihen.map(function (r) { return r.roh.map(function (x) { return x === null ? null : kurz(x); }); });
    var letzte = 0;
    labels.forEach(function (l) { for (var i = l.length - 1; i >= 0; i--) { if (l[i] !== null) { letzte = Math.max(letzte, breite(l[i], fw, true, fam)); break; } } });
    var katBreiten = d.kategorien.map(function (k) { return breite(k, fs, false, fam); });
    var randL = Math.max(12, katBreiten[0] / 2 - 6);
    var randR = Math.max(10, letzte / 2 + 4, katBreiten[n - 1] / 2 + 2);
    var oben = fw + 18;
    var unten = fs + 18;
    var x0 = links + randL;
    var x1 = W - randR;
    var yO = oben;
    var yU = H - unten;
    var xVon = function (i) { return n === 1 ? (x0 + x1) / 2 : x0 + (i * (x1 - x0)) / (n - 1); };
    var yVon = function (v) { return yU - (v / a.max) * (yU - yO); };
    var wurzel = svgWurzel(W, H);

    t.forEach(function (v, j) {
      var y = Math.round(yVon(v)) + 0.5;
      svg('line', { x1: links, x2: W, y1: y, y2: y, stroke: v === 0 ? NULLLINIE : GITTER, 'stroke-width': v === 0 ? 1.5 : 1 }, wurzel);
      schrift(wurzel, tickText[j], links - 8, y, { groesse: fs, anker: 'end' });
    });
    // Kategorien: jede k-te, die letzte immer (2026* soll stehen bleiben)
    var abstand = n > 1 ? (x1 - x0) / (n - 1) : x1 - x0;
    var maxKat = Math.max.apply(null, katBreiten);
    var schritt = 1;
    while (schritt < n && abstand * schritt < maxKat + 10) { schritt++; }
    d.kategorien.forEach(function (k, i) {
      if ((n - 1 - i) % schritt !== 0) { return; }
      schrift(wurzel, k, xVon(i), yU + 10 + fs * 0.6, { groesse: fs, anker: 'middle' });
    });

    var faden = svg('line', { 'class': 'th-diagramm__faden', x1: 0, x2: 0, y1: yO - 8, y2: yU, stroke: NULLLINIE, 'stroke-width': 1, visibility: 'hidden' }, wurzel);
    d.reihen.forEach(function (r, s) {
      var pfad = '';
      r.werte.forEach(function (w, i) { if (w !== null) { pfad += (pfad ? 'L' : 'M') + r1(xVon(i)) + ' ' + r1(yVon(w)); } });
      if (pfad) { svg('path', { 'class': 'th-diagramm__linie', d: pfad, fill: 'none', stroke: FARBE[s], 'stroke-width': kompakt ? 2.5 : 3, 'stroke-linejoin': 'round', 'stroke-linecap': 'round', pathLength: 1 }, wurzel); }
    });
    // Werte: auf dem Handy nur am letzten Punkt, sonst an jedem Punkt, wenn sie nebeneinander passen
    var maxLabel = 0;
    labels.forEach(function (l) { l.forEach(function (x) { if (x !== null) { maxLabel = Math.max(maxLabel, breite(x, fw, true, fam)); } }); });
    var alleWerte = !kompakt && abstand >= maxLabel + 8;
    var punktR = kompakt ? 4 : 4.5;
    var anker = [];
    var gruppen = [];
    for (var i = 0; i < n; i++) {
      var g = svg('g', { 'class': 'th-diagramm__gruppe', 'data-i': i }, wurzel);
      gruppen.push(g);
      var da = [];
      for (var s = 0; s < d.reihen.length; s++) {
        var w = d.reihen[s].werte[i];
        if (w === null) { continue; }
        da.push({ s: s, w: w, y: yVon(w) });
        svg('circle', { 'class': 'th-diagramm__punkt', cx: r1(xVon(i)), cy: r1(yVon(w)), r: punktR, fill: '#FFFFFF', stroke: FARBE[s], 'stroke-width': kompakt ? 2.5 : 3, 'data-s': s }, g);
      }
      if (!da.length) { anker.push({ x: xVon(i), y: yU, unten: yU }); continue; }
      da.sort(function (p, q) { return p.w === q.w ? p.s - q.s : q.w - p.w; });
      anker.push({ x: xVon(i), y: da[0].y, unten: da[da.length - 1].y });
      var letzterPunkt = d.reihen.some(function (r) { for (var j = r.werte.length - 1; j >= 0; j--) { if (r.werte[j] !== null) { return j === i; } } return false; });
      if (!alleWerte && !letzterPunkt) { continue; }
      // höchster Wert über den Punkt, niedrigster darunter, ein mittlerer (drei Reihen) nur im Tooltip
      da.forEach(function (p, idx) {
        if (da.length > 2 && idx > 0 && idx < da.length - 1) { return; }
        if (!alleWerte && d.reihen[p.s].werte.slice(i + 1).some(function (x) { return x !== null; })) { return; }
        var oberhalb = idx === 0;
        var y = oberhalb ? p.y - 8 - fw * 0.6 : p.y + 8 + fw * 0.6;
        if (!oberhalb && y + fw * 0.5 > yU - 2) { return; }
        schrift(g, labels[p.s][i], xVon(i), y, { groesse: fw, fett: true, anker: 'middle', farbe: WERT_FARBE[p.s], klasse: 'th-diagramm__wert' });
      });
    }
    return {
      svg: wurzel, H: H, quer: false, anker: anker,
      treffer: function (px) {
        var best = 0;
        for (var j = 1; j < n; j++) { if (Math.abs(xVon(j) - px) < Math.abs(xVon(best) - px)) { best = j; } }
        return best;
      },
      markieren: function (k) {
        if (k < 0) { faden.setAttribute('visibility', 'hidden'); } else { faden.setAttribute('x1', r1(xVon(k)) + 0.5); faden.setAttribute('x2', r1(xVon(k)) + 0.5); faden.setAttribute('visibility', 'visible'); }
        gruppen.forEach(function (g, j) {
          var an = j === k;
          g.classList.toggle('is-aktiv', an);
          Array.prototype.forEach.call(g.querySelectorAll('.th-diagramm__punkt'), function (c) {
            c.setAttribute('r', an ? punktR + 2 : punktR);
            c.setAttribute('fill', an ? FARBE[+c.getAttribute('data-s')] : '#FFFFFF');
          });
        });
      }
    };
  }

  /* ── Layout: stehende Balken (Desktop, wenige Kategorien auf dem Handy) ── */
  function layoutSaeulen(d, W, kompakt, fam) {
    var n = d.kategorien.length;
    var m = d.reihen.length;
    var fsMin = kompakt ? 13 : 12;
    var fsT = kompakt ? 13 : 14;
    var a = achse(maxWert(d), d.einheit);
    var t = ticks(a);
    var tickText = t.map(function (v) { return zahl(v, d.einheit); });
    var links = Math.ceil(Math.max.apply(null, tickText.map(function (x) { return breite(x, fsT, false, fam); }))) + 10;
    var x0 = links + 4;
    var gruppe = (W - x0) / n;
    var slot = Math.min(kompakt ? 48 : 60, (gruppe * (m > 1 ? 0.8 : 0.72)) / m);
    // Kategorien in höchstens drei Zeilen, Schrift 14 bis 12 (Handy 13); eine Zeile darf breiter als ihre
    // Gruppe sein, solange die Nachbarn in derselben Zeile frei bleiben („(Zusatztermin)“ unter „Februar“).
    // Passt es nicht, liegende Balken.
    var fs = kompakt ? 13 : 14;
    var zeilen = null;
    var probe = function (z) { return !!z; };
    for (; fs >= fsMin; fs--) {
      zeilen = d.kategorien.map(function (k) { return zeilenUmbruch(k, gruppe - 8, fs, fam); });
      if (zeilen.every(probe) && beschriftungPasst(zeilen, gruppe, x0, W, fs, fam)) { break; }
      zeilen = null;
    }
    if (!zeilen) { return null; }
    var zeilenMax = Math.max.apply(null, zeilen.map(function (z) { return z.length; }));
    // Werte über den Balken: eine Größe für alle, so groß wie möglich; sonst nur im Tooltip
    var labels = d.reihen.map(function (r) { return r.roh.map(function (x) { return x === null ? null : kurz(x); }); });
    var platz = m === 1 ? gruppe - 6 : slot - 1;
    var wfs = null;
    for (var g0 = kompakt ? 13 : 14; g0 >= (kompakt ? 13 : 12); g0--) {
      var passt = labels.every(function (l) { return l.every(function (x) { return x === null || breite(x, g0, true, fam) <= platz; }); });
      if (passt) { wfs = g0; break; }
    }
    var H = kompakt ? 280 : Math.max(300, Math.min(420, Math.round(W * 0.5)));
    var oben = (wfs || fsT) + 14;
    var unten = 12 + zeilenMax * (fs + 4) + 4;
    var yO = oben;
    var yU = H - unten;
    var yVon = function (v) { return yU - (v / a.max) * (yU - yO); };
    var wurzel = svgWurzel(W, H);
    t.forEach(function (v, j) {
      var y = Math.round(yVon(v)) + 0.5;
      svg('line', { x1: links, x2: W, y1: y, y2: y, stroke: v === 0 ? NULLLINIE : GITTER, 'stroke-width': v === 0 ? 1.5 : 1 }, wurzel);
      schrift(wurzel, tickText[j], links - 8, y, { groesse: fsT, anker: 'end' });
    });
    var anker = [];
    var gruppen = [];
    d.kategorien.forEach(function (k, i) {
      var mitte = x0 + gruppe * (i + 0.5);
      var g = svg('g', { 'class': 'th-diagramm__gruppe', 'data-i': i }, wurzel);
      gruppen.push(g);
      svg('rect', { 'class': 'th-diagramm__treffer', x: r1(x0 + gruppe * i), y: yO - 12, width: r1(gruppe), height: r1(H - yO + 12), fill: 'transparent' }, g);
      var oberste = yU;
      d.reihen.forEach(function (r, s) {
        var w = r.werte[i];
        if (w === null) { return; }
        var x = mitte - (slot * m) / 2 + s * slot;
        var y = yVon(w);
        oberste = Math.min(oberste, y);
        var pfad = balkenPfad(x + 1.5, y, slot - 3, yU - y, false);
        if (pfad) {
          var b = svg('path', { 'class': 'th-diagramm__balken', d: pfad, fill: FARBE[s] }, g);
          b.style.transitionDelay = (reduziert ? 0 : i * 45 + s * 20) + 'ms';
        }
        if (wfs) { schrift(g, labels[s][i], x + slot / 2, y - 6 - wfs * 0.5, { groesse: wfs, fett: true, anker: 'middle', farbe: WERT_FARBE[s], klasse: 'th-diagramm__wert' }); }
      });
      zeilen[i].forEach(function (z, zi) { schrift(g, z, mitte, yU + 12 + fs * 0.5 + zi * (fs + 4), { groesse: fs, anker: 'middle', klasse: 'th-diagramm__kat' }); });
      anker.push({ x: mitte, y: oberste - (wfs ? wfs + 8 : 2), unten: yU });
    });
    return {
      svg: wurzel, H: H, quer: false, anker: anker,
      treffer: function (px) { return Math.max(0, Math.min(n - 1, Math.floor((px - x0) / gruppe))); },
      markieren: function (k) { gruppen.forEach(function (g, j) { g.classList.toggle('is-aktiv', j === k); }); }
    };
  }

  /* ── Layout: liegende Balken (Handy mit vielen Kategorien, oder wenn die Beschriftung nicht passt) ── */
  function layoutQuer(d, W, kompakt, fam) {
    var n = d.kategorien.length;
    var m = d.reihen.length;
    var fs = 14;
    var fsT = 13;
    var wfs = 13;
    var bh = m === 1 ? 18 : kompakt ? 14 : 16;
    var luft = 4;
    var abstand = kompakt ? 14 : 16;
    var a = achse(maxWert(d), d.einheit);
    var t = ticks(a);
    var tickText = t.map(function (v) { return zahl(v, d.einheit); });
    var labels = d.reihen.map(function (r) { return r.roh.map(function (x) { return x === null ? null : kurz(x); }); });
    var wertBreite = 0;
    labels.forEach(function (l) { l.forEach(function (x) { if (x !== null) { wertBreite = Math.max(wertBreite, breite(x, wfs, true, fam)); } }); });
    var x0 = Math.max(2, breite(tickText[0], fsT, false, fam) / 2 + 1);
    var x1 = Math.min(W - wertBreite - 8, W - breite(tickText[tickText.length - 1], fsT, false, fam) / 2 - 2);
    var xVon = function (v) { return x0 + (v / a.max) * (x1 - x0); };
    // erst die Höhe bestimmen, dann zeichnen
    var zeilen = d.kategorien.map(function (k) { return umbrechen(k, W - 2, fs, fam) || [kuerzen(k, W - 2, fs, fam)]; });
    var reihen = [];
    var y = 2;
    for (var i = 0; i < n; i++) {
      var top = y;
      var balkenTop = top + zeilen[i].length * (fs + 4) + 4;
      var bottom = balkenTop + m * bh + (m - 1) * luft;
      reihen.push({ top: top, balkenTop: balkenTop, bottom: bottom });
      y = bottom + abstand;
    }
    var gitterUnten = y - abstand + 6;
    var H = Math.ceil(gitterUnten + fsT + 12);
    var wurzel = svgWurzel(W, H);
    t.forEach(function (v, j) {
      var x = Math.round(xVon(v)) + 0.5;
      svg('line', { x1: x, x2: x, y1: reihen[0].balkenTop - 4, y2: gitterUnten, stroke: v === 0 ? NULLLINIE : GITTER, 'stroke-width': v === 0 ? 1.5 : 1 }, wurzel);
      schrift(wurzel, tickText[j], x, gitterUnten + 6 + fsT * 0.5, { groesse: fsT, anker: 'middle' });
    });
    var anker = [];
    var gruppen = [];
    d.kategorien.forEach(function (k, i) {
      var z = reihen[i];
      var g = svg('g', { 'class': 'th-diagramm__gruppe', 'data-i': i }, wurzel);
      gruppen.push(g);
      svg('rect', { 'class': 'th-diagramm__treffer', x: 0, y: r1(z.top - abstand / 2), width: W, height: r1(z.bottom - z.top + abstand), fill: 'transparent' }, g);
      zeilen[i].forEach(function (zeile, zi) { schrift(g, zeile, 1, z.top + fs * 0.5 + zi * (fs + 4), { groesse: fs, farbe: TEXT_STARK, klasse: 'th-diagramm__kat' }); });
      var rechts = x0;
      d.reihen.forEach(function (r, s) {
        var by = z.balkenTop + s * (bh + luft);
        var w = r.werte[i];
        if (w === null) {
          schrift(g, 'keine Angabe', x0 + 4, by + bh / 2, { groesse: 13, farbe: TEXT, klasse: 'th-diagramm__wert' });
          return;
        }
        var ende = xVon(w);
        rechts = Math.max(rechts, ende);
        var pfad = balkenPfad(x0, by, ende - x0, bh, true);
        if (pfad) {
          var b = svg('path', { 'class': 'th-diagramm__balken', d: pfad, fill: FARBE[s] }, g);
          b.style.transitionDelay = (reduziert ? 0 : i * 45 + s * 20) + 'ms';
        }
        schrift(g, labels[s][i], ende + 6, by + bh / 2, { groesse: wfs, fett: true, farbe: WERT_FARBE[s], klasse: 'th-diagramm__wert' });
      });
      anker.push({ x: Math.min(W - 8, Math.max(W * 0.3, rechts)), y: z.top - 4, unten: z.bottom });
    });
    return {
      svg: wurzel, H: H, quer: true, anker: anker,
      treffer: function (px, py) {
        for (var j = 0; j < n; j++) { if (py < reihen[j].bottom + abstand / 2) { return j; } }
        return n - 1;
      },
      markieren: function (k) { gruppen.forEach(function (g, j) { g.classList.toggle('is-aktiv', j === k); }); }
    };
  }

  /* ── Ein Diagramm ── */
  function Diagramm(fig, d) {
    var self = this;
    this.fig = fig;
    this.d = d;
    this.aktiv = -1;
    this.tastatur = false;
    this.zeiger = false;
    this.breite = 0;
    this.geo = null;
    this.img = fig.querySelector('img');
    var alt = (this.img && this.img.getAttribute('alt')) || d.titel;
    var id = 'th-diagramm-' + (++zaehler);

    var karte = el('div', 'th-diagramm__karte');
    var kopf = el('div', 'th-diagramm__kopf', karte);
    kopf.setAttribute('aria-hidden', 'true');
    el('p', 'th-diagramm__titel', kopf).textContent = d.titel;
    if (d.reihen.length > 1) {
      var legende = el('ul', 'th-diagramm__legende', kopf);
      d.reihen.forEach(function (r, i) {
        var li = el('li', '', legende);
        var key = el('span', 'th-diagramm__key th-diagramm__key--' + (d.art === 'linie' ? 'linie' : 'flaeche'), li);
        key.style.setProperty('--th-dia-farbe', FARBE[i]);
        el('span', '', li).textContent = r.name;
      });
    }
    var flaeche = el('div', 'th-diagramm__flaeche', karte);
    flaeche.setAttribute('role', 'img');
    flaeche.setAttribute('aria-label', alt);
    flaeche.setAttribute('aria-describedby', id + '-hinweis');
    flaeche.tabIndex = 0;
    var tip = el('div', 'th-diagramm__tip', flaeche);
    tip.setAttribute('aria-hidden', 'true');
    tip.hidden = true;
    var hinweis = el('span', 'th-diagramm__sr', karte);
    hinweis.id = id + '-hinweis';
    hinweis.textContent = 'Mit den Pfeiltasten werden die Werte einzeln angesagt. Alle Werte stehen auch in der Tabelle unter dem Diagramm.';
    var ansage = el('p', 'th-diagramm__sr', karte);
    ansage.setAttribute('aria-live', 'polite');
    this.karte = karte;
    this.flaeche = flaeche;
    this.tip = tip;
    this.ansage = ansage;

    // Die Karte bleibt verborgen (CSS), bis das erste Zeichnen gelingt; bis dahin zeigt die Figur ihr PNG
    fig.insertBefore(karte, fig.firstChild);

    flaeche.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch' || !self.geo) { return; }
      self.tastatur = false;
      self.setzen(self.trefferAus(e), false);
    });
    flaeche.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') { return; }
      if (!self.tastatur) { self.setzen(-1, false); }
    });
    flaeche.addEventListener('pointerdown', function (e) {
      if (!self.geo) { return; }
      self.zeiger = true;
      self.tastatur = false;
      var i = self.trefferAus(e);
      if (e.pointerType === 'touch' && i === self.aktiv) { self.setzen(-1, false); } else { self.setzen(i, false); }
    });
    flaeche.addEventListener('pointerup', function () { self.zeiger = false; });
    flaeche.addEventListener('focus', function () {
      if (self.zeiger || self.aktiv >= 0) { return; }
      self.tastatur = true;
      self.setzen(0, true);
    });
    flaeche.addEventListener('blur', function () { self.tastatur = false; self.setzen(-1, false); });
    flaeche.addEventListener('keydown', function (e) {
      var n = self.d.kategorien.length;
      var i = self.aktiv;
      var neu = null;
      switch (e.key) {
        case 'ArrowRight': case 'ArrowDown': neu = i < 0 ? 0 : Math.min(n - 1, i + 1); break;
        case 'ArrowLeft': case 'ArrowUp': neu = i < 0 ? 0 : Math.max(0, i - 1); break;
        case 'Home': neu = 0; break;
        case 'End': neu = n - 1; break;
        case 'Escape': if (i >= 0) { neu = -1; } break;
        default: return;
      }
      if (neu === null) { return; }
      e.preventDefault();
      self.tastatur = true;
      self.setzen(neu, neu >= 0);
    });

    // Neu zeichnen, wenn sich die Breite der Figur ändert (Drehen, Fenstergröße, Seitenleiste)
    this.figBreite = 0;
    if ('ResizeObserver' in window) {
      this.beobachter = new window.ResizeObserver(function () {
        var w = Math.floor(fig.clientWidth);
        if (w !== self.figBreite) { self.figBreite = w; self.planen(); }
      });
      this.beobachter.observe(fig);
    } else {
      window.addEventListener('resize', function () { self.planen(); });
    }
  }

  Diagramm.prototype.trefferAus = function (e) {
    var r = this.flaeche.getBoundingClientRect();
    return this.geo.treffer(e.clientX - r.left, e.clientY - r.top);
  };

  Diagramm.prototype.planen = function (immer) {
    var self = this;
    if (immer) { this.breite = 0; }
    if (this.rahmen) { return; }
    this.rahmen = (window.requestAnimationFrame || window.setTimeout)(function () {
      self.rahmen = 0;
      self.zeichnen();
    });
  };

  Diagramm.prototype.zeichnen = function () {
    try {
      var fig = this.fig;
      // versteckt (z. B. Druckansicht, eingeklappter Bereich) oder zu schmal: PNG bleibt, später neu versuchen
      if (fig.clientWidth < 200) { return; }
      var erstes = !fig.classList.contains('th-diagramm--aktiv');
      if (erstes) { fig.classList.add('th-diagramm--aktiv'); }
      var W = Math.floor(this.flaeche.clientWidth);
      if (W < 160) {
        if (erstes) { fig.classList.remove('th-diagramm--aktiv'); }
        return;
      }
      if (W === this.breite) { return; }
      var fam = window.getComputedStyle(this.flaeche).fontFamily || 'sans-serif';
      var kompakt = W < KOMPAKT;
      var d = this.d;
      var geo;
      if (d.art === 'linie') {
        geo = layoutLinie(d, W, kompakt, fam);
      } else {
        geo = kompakt && d.kategorien.length > 3 ? null : layoutSaeulen(d, W, kompakt, fam);
        if (!geo) { geo = layoutQuer(d, W, kompakt, fam); }
      }
      if (this.geo && this.geo.svg.parentNode) { this.geo.svg.parentNode.replaceChild(geo.svg, this.geo.svg); } else { this.flaeche.insertBefore(geo.svg, this.tip); }
      this.geo = geo;
      this.breite = W;
      this.fig.classList.toggle('th-diagramm--quer', !!geo.quer);
      this.fig.classList.toggle('th-diagramm--kompakt', kompakt);
      if (this.aktiv >= 0) { this.setzen(this.aktiv, false); }
    } catch (e) {
      this.abbauen(e);
    }
  };

  Diagramm.prototype.setzen = function (i, ansagen) {
    if (!this.geo) { return; }
    this.aktiv = i;
    this.geo.svg.classList.toggle('ist-aktiv', i >= 0);
    this.geo.markieren(i);
    var tip = this.tip;
    if (i < 0) { tip.hidden = true; return; }
    var d = this.d;
    tip.textContent = '';
    el('p', 'th-diagramm__tip-kopf', tip).textContent = d.kategorien[i];
    var liste = el('ul', 'th-diagramm__tip-liste', tip);
    var teile = [];
    d.reihen.forEach(function (r, s) {
      var li = el('li', '', liste);
      var key = el('span', 'th-diagramm__tip-key', li);
      key.style.background = FARBE[s];
      var wert = r.roh[i] === null ? 'keine Angabe' : kurz(r.roh[i]);
      el('strong', '', li).textContent = wert;
      if (d.reihen.length > 1) { el('span', 'th-diagramm__tip-name', li).textContent = r.name; }
      teile.push((d.reihen.length > 1 ? r.name + ' ' : '') + wert.replace(/ /g, ' '));
    });
    tip.hidden = false;
    var a = this.geo.anker[i];
    var W = this.breite;
    var tw = tip.offsetWidth;
    var th = tip.offsetHeight;
    var left = Math.max(0, Math.min(W - tw, a.x - tw / 2));
    var top = a.y - th - 10;
    if (top < -40) { top = Math.min(this.geo.H - th, a.unten + 14); }
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    if (ansagen) { this.ansage.textContent = d.kategorien[i].replace(/\*$/, '') + ': ' + teile.join(', '); }
  };

  Diagramm.prototype.abbauen = function (fehler) {
    if (this.beobachter) { this.beobachter.disconnect(); }
    if (this.karte.parentNode) { this.karte.parentNode.removeChild(this.karte); }
    this.fig.classList.remove('th-diagramm--aktiv', 'th-diagramm--quer', 'th-diagramm--kompakt', 'th-diagramm--animiert', 'th-diagramm--sichtbar', 'th-diagramm--fertig');
    this.geo = null;
    if (fehler && window.console && window.console.warn) { window.console.warn('th-diagramm: PNG bleibt', fehler); }
  };

  /* ── Einblenden beim Hineinscrollen (nicht bei prefers-reduced-motion) ── */
  var sicht = !reduziert && 'IntersectionObserver' in window ? new window.IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      if (!e.isIntersecting) { return; }
      sicht.unobserve(e.target);
      var fig = e.target;
      var weiter = window.requestAnimationFrame || window.setTimeout;
      weiter(function () {
        weiter(function () {
          fig.classList.add('th-diagramm--sichtbar');
          window.setTimeout(function () { fig.classList.add('th-diagramm--fertig'); }, 1800);
        });
      });
    });
  }, { threshold: 0.25 }) : null;

  function verbessern(fig) {
    if (fig.__thDiagramm) { return; }
    fig.__thDiagramm = true;
    var d = null;
    try { d = pruefe(JSON.parse(fig.getAttribute('data-diagramm') || '')); } catch (e) { d = null; }
    if (!d) { return; } // PNG bleibt
    var x;
    try {
      x = new Diagramm(fig, d);
    } catch (e) {
      if (window.console && window.console.warn) { window.console.warn('th-diagramm: PNG bleibt', e); }
      var k = fig.querySelector('.th-diagramm__karte');
      if (k) { k.parentNode.removeChild(k); }
      fig.classList.remove('th-diagramm--aktiv');
      return;
    }
    alle.push(x);
    if (sicht) {
      fig.classList.add('th-diagramm--animiert');
      sicht.observe(fig);
    }
    x.zeichnen();
  }

  function init(wurzel) {
    var figs = (wurzel || document).querySelectorAll('figure.th-diagramm[data-diagramm]');
    for (var i = 0; i < figs.length; i++) { verbessern(figs[i]); }
  }

  /* Tippen außerhalb schließt den Tooltip (Touch) */
  document.addEventListener('pointerdown', function (e) {
    alle.forEach(function (x) { if (x.aktiv >= 0 && !x.karte.contains(e.target)) { x.setzen(-1, false); } });
  }, true);
  /* Schriften geladen: neu messen und zeichnen */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { alle.forEach(function (x) { x.planen(true); }); });
  }
  /* Druck: das PNG zeigt sich (CSS); lazy laden erzwingen, damit es da ist */
  window.addEventListener('beforeprint', function () {
    alle.forEach(function (x) { if (x.img) { x.img.loading = 'eager'; } });
  });

  window.thDiagramm = { init: init, pruefe: pruefe, version: 1 };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})(window, document);
